export const SeparatorDefault = () => (
    <>
     <hr className='separator-default' />
    </>
    )